import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class VoiceRecognitionService {
  private recognition: any;
  private isStoppedSpeechRecog = false;
  public text = '';
  private voiceToTextSubject: Subject<string> = new Subject();
  private tempWords: string = '';

  constructor() {
    this.init();
  }

  speechInput() {
    return this.voiceToTextSubject.asObservable();
  }

  private init() {
    const SpeechRecognition = window.SpeechRecognition || window.webkitSpeechRecognition;
    if (SpeechRecognition) {
      this.recognition = new SpeechRecognition();
      this.recognition.interimResults = true;
      this.recognition.lang = 'en-US';
  
      this.recognition.addEventListener('result', (e: any) => {
        const interimTranscripts = Array.from(e.results)
          .filter((result: any) => result.isFinal)
          .map((result: any) => result[0].transcript)
          .join('');

        const interimTranscriptsTemp = Array.from(e.results)
          .filter((result: any) => !result.isFinal)
          .map((result: any) => result[0].transcript)
          .join('');

        this.tempWords = interimTranscriptsTemp;
        this.text += interimTranscripts ? ` ${interimTranscripts}` : '';
        this.voiceToTextSubject.next(this.text.trim());
      });
  
      this.recognition.addEventListener('end', () => {
        if (!this.isStoppedSpeechRecog) {
          this.wordConcat();
          setTimeout(() => {
            this.recognition.start();
          }, 500); // Adjust the delay if needed
        }
      });
    } else {
      console.warn('Speech Recognition API is not supported in this browser. For using voice query, please use Chrome.');
    }
  }
  
  start() {
    if (this.recognition) {
      this.voiceToTextSubject.next('');
      this.text = '';
      this.isStoppedSpeechRecog = false;
      this.recognition.start();
    }
  }

  stop() {
    if (this.recognition) {
      this.isStoppedSpeechRecog = true;
      this.wordConcat();
      this.recognition.stop();
      this.clearPreviousMessages();
    }
  }

  private wordConcat() {
    this.text += this.tempWords ? ` ${this.tempWords}` : '';
    this.text = this.text.trim();
    this.tempWords = '';
    this.voiceToTextSubject.next(this.text);
  }

  public clearPreviousMessages() {
    this.voiceToTextSubject.next('');
    this.text = '';
  }
}
